<template lang="pug">
    el-dialog(:title="accountType==1?'绑定家长':'绑定青少年'",:fullscreen="false",:visible.sync="visible" width="80%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm()")
        el-row(v-if='visible')
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='memberName' clearable='', style='width:80%;' :placeholder="accountType==1?'请输入姓名/级别/手机号码':'请输入姓名/级别'")
                            el-col(:span='2')
                                el-button(@click="queryList" style='float:right;' icon='el-icon-search') 查询
                    div
                        el-table(ref="leftData" row-key="id"  :data="leftData" border @select="cellClickFun" @select-all="selectAllFun" @selection-change="checkLeftMemberAll" max-height="300" )
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(v-if="accountType==1" prop="mobile" label="手机号码" align='center' ) 
                            el-table-column(v-if="accountType==0" prop="idCard" label="身份证号" align='center' )                         
                            el-table-column( type="selection" align='center' reserve-selection=true)
                    el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 已选择的人员
                    div
                        el-table(ref="rightData" row-key="id" :data="rightDataing" border max-height="317")
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(v-if="accountType==1" prop="mobile" label="手机号码" align='center' )
                            el-table-column(v-if="accountType==0" prop="idCard" label="身份证号" align='center' )
                            el-table-column(fixed="right" label="操作" align='center')
                                template(slot-scope="scope")
                                    i(class="el-icon-error" style='color:#f56c6c;cursor:pointer;font-size: 18px;' @click.prevent="deleteRowLeftMember(scope.$index, rightDataing)")
                                    //- el-button( @click.native.prevent="deleteRowLeftMember(scope.$index, rightDataing)" type="text" size="small") 移除
                    el-pagination( :current-page='pageIndex1', :page-sizes='[10, 20, 50, 100]', :page-size='100000', :total='rightDataing.length', layout='total ')
        span.dialog-footer(slot="footer")
            el-button(@click="addEnrollClubMember" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
export default {
  data () {
    return {
        visible: false,
        memberName: '',
        leftData: [], //添加队员左侧列表
        rightData: [], //添加队员右侧列表
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        pageIndex1: 1,
        pageSize1: 10,
        selectEnrollData: {},
        enrollMember: {},
        rightDataEnroll: [], //当前俱乐部已参赛队员
        ruleForm: {},
        accountType:"",
        mbId:"",
        deletedList:[],
        // isScrollLoading:false
    }
  },
  computed: {
    rightDataing() {
      return this.rightData
    }
  },
  watch: {
  },
  methods: {
    openFullScreen () {
        this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    },
    //添加队员
    init (id, accountType) {
        this.visible = true
        this.pageIndex = 1,
        this.pageSize = 10,
        this.pageIndex1 = 1,
        this.pageSize1 = 10,
        // this.isScrollLoading=false
        // this.$forceUpdate()
        // if (ruleForm) {
        //     this.ruleForm = ruleForm
        // }
        this.mbId=id
        this.accountType=accountType
        this.memberName = ''
        // this.selectEnrollData = row
        this.enrollMember = {}
        // this.enrollMember.ctId = this.ruleForm.id
        this.enrollMember.id = id
        this.leftData = []
        this.rightData = []
        this.rightDataEnroll = []
        this.getLeftData()
        this.getRightData()

    },
    getLeftData () {
        var data={
                'page': this.pageIndex,
                'limit': this.pageSize,
                'id':this.mbId,
                'accountType':this.accountType,
                'name':this.memberName
        }
        this.$http({
            url: this.$http.adornUrl('/mbMember/getMemberListNoTeen'),
            method: 'POST',
            data
        }).then(res => {
            if (res && res.code === 0) {
                this.leftData = res.page.records
                this.totalPage = res.page.total
                this.leftData.forEach(b => {
                    this.$refs.leftData.toggleRowSelection(b, false)
                })
                this.lefChecked()
                //查询俱乐部已报名队员
                // if(this.isScrollLoading) return
            } else {
                this.leftData = []
                this.totalPage = 0
            }
        })
    },
    getRightData() {
        var data={
            'page': this.pageIndex1,
            'limit': 10000,
            'id':this.mbId,
            'accountType':this.accountType,
            'name':this.memberName
        }
         this.rightData = []
        this.$http({
            url: this.$http.adornUrl('/mbMember/getMemberListTeen'),
            method: 'POST',
            data
        }).then(res => {
            if (res && res.code === 0) {
                if (res.page.records && res.page.records.length > 0) {
                    
                    let arr = res.page.records
                    this.rightData = res.page.records
                    this.rightDataEnroll = arr
                    this.lefChecked()
                }
            }
        })
    },
    // 左侧绑定
    lefChecked () {
        let arr = this.rightData
        arr.forEach(e => {
            this.leftData.forEach(b => {
                if (e.id === b.id) {
                    this.$refs.leftData.toggleRowSelection(b, true)
                }
            })
        })
    },
    selectAllFun (row) {
        if (row.length === 0) {
            this.leftData.forEach(e => {
                this.rightData.forEach((ite, idx) => {
                    if (ite.id === e.id) {
                        this.rightData.splice(idx, 1)
                    }
                })
            })
        }

    },
    // 取消状态时 删除右侧数据
    cellClickFun (row, column) {
        const isSelected = this.$refs.leftData.selection.includes(column);
        if (!isSelected) {
            this.rightData.forEach((ite, idx) => {
                if (ite.id === column.id) {
                    this.rightData.splice(idx, 1)
                }
            })
        }
    },
    //选中添加队员左侧列表
    checkLeftMemberAll (e) {
        if (this.accountType === 1) {
            this.rightData = e;
        } else {
            this.rightData = this.uniqueByProperty([this.rightData, e], 'id');
        }
    },
    // 去重添加
    uniqueByProperty(arrays, prop) {
        const seen = new Set();
        return arrays.flat().filter(item => {
            const val = item[prop];
            return seen.has(val) ? false : seen.add(val);
        });
    },
    queryList(){
       this.pageIndex=1
       this.rightData = []
       this.getLeftData()
       this.getRightData()
    },
    // 每页数l
    sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.$refs.leftData.clearSelection();
        this.getLeftData()
    },
    // 当前页l
    currentChangeHandle (val) {
      this.pageIndex = val
      this.$refs.leftData.clearSelection();
      this.getLeftData()
    },
    deleteRowLeftMember (index, rows) {
        this.leftData.forEach(b => {
            if (rows[index].id === b.id) {
                this.$refs.leftData.toggleRowSelection(b, false)
            }
        })
        this.rightData.splice(index, 1)
        this.deletedList.push(rows)
    },

    //添加俱乐部参赛会员
    addEnrollClubMember () {
        // if (this.rightData.length === 0) {
        
        // } else 
        // if (this.rightData.length > 0) {

            if(this.accountType === 1 && this.rightData.length>1){
               this.$message.error('一名青少年仅支持绑定一位家长，请重新选择！')
               return
            }

            var bindMbIds=[]
            this.rightData.forEach(item=>{
                bindMbIds.push(item.id)
            })
            var data={
                accountType:this.accountType,
                mbId:this.mbId,
                bindMbIds:bindMbIds
            }
                        this.$http({
                            url: this.$http.adornUrl(`/mbMember/saveMemberParentTeen`),
                            method: 'post',
                            data
                        }).then(data => {
                            if (data && data.code === 0) {
                                    this.$message.success('操作成功!')
                                    this.visible = false
                                    this.rightData = []
                            } else {
                                this.$message.success('操作失败!')
                            }
                        })

        // }
    },
    closeForm () {
        this.visible = false
    }

  }
}
</script>
<style scoped>

/deep/ input[aria-hidden="true"] {
    display: none !important;
}
</style>

